export default __webpack_public_path__ + "static/media/DNo.1-0.3cd70141.jpg";